<template>
	<div class="main-contents">
		<div class="contents">
			<div class="contents_body">
				<div class="tit">
					<span @click="pass()">본인인증</span><br/>
					휴대폰 본인인증을 해 주세요.
				</div>

				<div class="joinbox" style="height: 420px;">
					<div>
						<p class="mb-10">휴대폰 본인인증</p>
						<div class="certification" @click="openCert()">
							<span>휴대폰 본인인증 하기</span>
						</div>
					</div>
				</div>
			</div>
		</div>		

		<!-- 
		<input type="text" name="comm_id" 		:value="kcpcert.comm_id" />
		<input type="text" name="phone_no" 		:value="kcpcert.phone_no" />
		<input type="text" name="user_name" 	:value="kcpcert.user_name"/>
		<input type="text" name="birth_day" 	:value="kcpcert.birth_day" />
		<input type="text" name="sex_code"		:value="kcpcert.sex_code" />
		<input type="text" name="ci" 			:value="kcpcert.ci" />
		<input type="text" name="di" 			:value="kcpcert.di" />
		 -->
	
	</div>
</template>

<script>
import { signupVerifyMeta } from '@/utils/meta';
export default {
	metaInfo : signupVerifyMeta,
	data() {
		return {
			kcpcert : {},
			mberInfo : {},
		}
	},

	beforeMount() {
		if(this.$route.params) {
			this.mberInfo = this.$route.params.forwardData;
		}else {
			this.$router.replace({name : 'MEM003M01'});
		}

		// console.log('mberInfo', this.mberInfo);
	},

	methods : {
		openCert() {
			this.$.kcpCert(this, function(this_obj, res) {
				this_obj.kcpcert = res;
				this_obj.mberchk();
			});

		},

		mberchk() {
			var param = {
				di : this.kcpcert.di,
				ci : this.kcpcert.ci,
				mberDivCd : this.mberInfo.mberDivCd
			};

			this.$.httpPost('/api/mem/memberChk', param,'')
				.then(res => {
					if(res.data.resultCode == '000') {
						if(res.data.idMap) {
							alert('이미 등록된 회원입니다.');
							return false;
						}else {
							this.mberInfo.kcpcert = this.kcpcert;
							this.$router.push({name:'MEM004M03', params:{secrets : this.mberInfo}});
						}
					}
				})
		},
		
		moveBack() {
			this.$router.go(-1);
		},

		pass() {
			if(this.$store.state.profile.name == '운영') {
				var admininput = prompt("입력");
				if(admininput == 'coffee ') {
					this.mberInfo.pass = true;
					this.$router.push({name:'MEM004M03', params:{secrets : this.mberInfo}});
				}
			} else {
				this.mberInfo.pass = true;
				this.$router.push({name:'MEM004M03', params:{secrets : this.mberInfo}});
			}

		}
	}
}
</script>